// Copies AI Studio grid images into the company's "AI Studio" File Browser folder
// (POR-14659). Plain images are copied server-side from the path the app already
// produced; a tile with a separate product layer or Cambridge callouts is
// composited here exactly like the download and uploaded.
import { composeAttachmentBlob } from '@frontend/utils';

const pending = new Map();

function sameOriginPath(url) {
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.origin === window.location.origin ? parsed.pathname + parsed.search : null;
  } catch (e) {
    return null;
  }
}

async function postToLibrary({ url, overlayUrl, _mrhiCallouts, name }) {
  const form = new FormData();
  form.append('name', name);

  const hasLayer = !!overlayUrl || !!(_mrhiCallouts && _mrhiCallouts.type === 'cambridge');
  const path = sameOriginPath(url);

  if (!hasLayer && path && (path.startsWith('/temp/') || path.startsWith('/share?'))) {
    form.append('image_url', path);
  } else {
    const blob = await composeAttachmentBlob({ payload: url, overlayUrl, _mrhiCallouts });
    if (!blob) return null;
    form.append('image', blob, `${name}.png`);
  }

  const { data } = await axios.post('/networks/ai-studio-library', form);

  return (data && data.url) ? data : null;
}

// Resolves to { id, url } or null; never rejects. Concurrent calls for the same
// image share one request.
export function saveImageToAiStudio({ url, overlayUrl = null, _mrhiCallouts = null, name }) {
  if (!url) return Promise.resolve(null);
  if (pending.has(url)) return pending.get(url);

  const promise = postToLibrary({ url, overlayUrl, _mrhiCallouts, name: name || 'AI Studio image' })
    .catch((e) => {
      console.warn('AI Studio library save failed', e);
      return null;
    })
    .finally(() => {
      setTimeout(() => pending.delete(url), 0);
    });

  pending.set(url, promise);

  return promise;
}

export function pendingAiStudioSave(url) {
  return pending.get(url) || null;
}
